
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import FAQ from "../Components/Faq/FAQ";
import AddFAQ from "../Components/Faq/AddFAQ";
const FaqRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  return (
    <Routes>
      <Route path="/faq" element={<FAQ />}></Route>
      <Route path="/faq/addFQ" element={canAdd ? <AddFAQ /> : <Navigate to="/faq" replace />}></Route>
    </Routes>
  );
};
export default FaqRoutes;
